import { Autocomplete, FormControl, TextField } from '@mui/material';
import {
  CUSTOMER_FILTERS_TABLE_STATE_KEY,
  ICustomerFilterState,
  getLocalStoredCustomerFiltersState,
} from 'customer-management/state/customerFilterState';
import { useMemo } from 'react';
import { FilterProps } from 'react-table';
import { useLocalStorage } from 'shared/hooks';
import { CustomerManagementGridItem } from 'shared/types/customerManagement';

export function SelectColumnFilter({
  column: { render, setFilter, preFilteredRows, id },
}: FilterProps<CustomerManagementGridItem>) {
  const [localStorageValue, setLocalStorageValue] = useLocalStorage<ICustomerFilterState>(
    CUSTOMER_FILTERS_TABLE_STATE_KEY,
    getLocalStoredCustomerFiltersState()
  );
  const defaultValue = localStorageValue.filters?.find(f => f.id === id)?.value || undefined;
  const options = useMemo(() => {
    const options = new Set<any>();
    preFilteredRows.forEach(row => {
      options.add(row.values[id]);
    });
    return [...Array.from(options.values())].sort();
  }, [id, preFilteredRows]);

  return (
    <FormControl fullWidth>
      <Autocomplete
        disablePortal
        defaultValue={defaultValue}
        id={`${id}-filter-select`}
        options={options.map((option, i) => option)}
        onChange={(event, value) => {
          setFilter(value || undefined);
          const storedValue = getLocalStoredCustomerFiltersState();
          if (storedValue.filters) {
            if (storedValue.filters.some(f => f.id === id)) {
              const storedFilters = storedValue.filters;
              if (value) {
                storedFilters.filter(f => f.id === id)[0].value = value || undefined;
              } else {
                storedFilters.splice(
                  storedFilters.findIndex(f => f.id === id),
                  1
                );
              }
              setLocalStorageValue({
                filters: [...storedFilters],
              });
            } else {
              setLocalStorageValue({
                filters: [...storedValue.filters, { id, value: value || undefined }],
              });
            }
          } else {
            setLocalStorageValue({
              filters: [{ id, value: value || undefined }],
            });
          }
        }}
        renderInput={params => <TextField {...params} label={render('Header')} />}
      />
    </FormControl>
  );
}
